import React from 'react';
import PropTypes from 'prop-types';
import { useAuthUser } from './AuthHooks';
import AppLoader from '../core/AppLoader';
// import axios from 'axios';


// const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://apigw.kubekkp.coofis.com/sipeg/';

// const api = axios.create({
//     baseURL: BASE_URL,
//     headers: {
//         Authorization: `Bearer ${localStorage.getItem('token')}`
//     }
// });


const AuthRoutes = ({ children }) => {
  const { isLoading } = useAuthUser();

  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token'); // You might store it in localStorage/sessionStorage

    // if (token) {
    //   api.interceptors.response.use(
    //     response => response, 
    //     async error => {
    //         if (error.response.status === 401) {
    //              window.location.href = 'https://sipeg.kubekkp.coofis.com/oidc/authenticate/';
    //         }
    //         return Promise.reject(error);
    //     }
    // );
    // }else{
    //   window.location.href = 'https://sipeg.kubekkp.coofis.com/oidc/authenticate/'; // Redirect to external link
    // }

    if (!token) window.location.replace('https://sipeg.kubekkp.coofis.com/oidc/authenticate/');
  };


  // checkTokenExpiration()

  return isLoading ? <AppLoader /> : <>{children}</>;
};

export default AuthRoutes;

AuthRoutes.propTypes = {
  children: PropTypes.node.isRequired,
};
